import CollectionsContext from '@/context/CollectionsContext';
import useCollectionsOnlyForContext from '@/hooks/collections/useCollectionsOnlyForContext';

export const CollectionsProvider = ({
	children,
}: {
	children: React.ReactNode;
}) => {
	const useCollectionsOutcome = useCollectionsOnlyForContext();

	return (
		<CollectionsContext.Provider value={useCollectionsOutcome}>
			{children}
		</CollectionsContext.Provider>
	);
};
